// frontend\src\components\LensesInput.js
import { useState, useEffect, useRef } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

const LensesInput = ({ value, options, onChange, placeholder }) => {
  const [selected, setSelected] = useState([]);
  const typeaheadRef = useRef(null);

  useEffect(() => {
    const lensesArray = value 
      ? value.split(',')
          .map(lens => lens.trim())
          .filter(lens => lens.length > 0)
          .map(lens => ({ label: lens }))
      : [];
    setSelected(lensesArray);
  }, [value]);

  const handleChange = (selectedItems) => {
    setSelected(selectedItems);
    onChange(selectedItems.map(item => item.label).join(', '));
  };

  const handleInputChange = (text, e) => {
    // Добавление по запятой
    if (text.endsWith(',')) {
      const newLens = text.slice(0, -1).trim();
      if (newLens) {
        const newSelected = [...selected, { label: newLens }];
        handleChange(newSelected);
        if (typeaheadRef.current) {
          typeaheadRef.current.clear();
          typeaheadRef.current.focus();
        }
      }
      return '';
    }
    return text;
  };

  const handleKeyDown = (e) => {
    // Добавление по Enter, только если не открыто меню выбора
    if (e.key === 'Enter' && e.target.value.trim() && !typeaheadRef.current?.state?.showMenu) {
      const newSelected = [...selected, { label: e.target.value.trim() }];
      handleChange(newSelected);
      if (typeaheadRef.current) {
        typeaheadRef.current.clear();
        typeaheadRef.current.focus();
      }
      e.preventDefault();
    }
  };

  return (
    <Typeahead
      ref={typeaheadRef}
      id="lenses-typeahead"
      multiple
      allowNew
      newSelectionPrefix=""
      options={options.map(opt => ({ label: opt }))}
      selected={selected}
      onChange={handleChange}
      onInputChange={handleInputChange}
      placeholder={placeholder}
      labelKey="label"
      inputProps={{
        onKeyDown: handleKeyDown,
      }}
    />
  );
};

export default LensesInput;